module.exports = __webpack_public_path__ + "img/PyramidProgressives_DG.e452522d.png";